import React from "react"
import DeleteFilter from "../../../../assets/iconos/close.svg";
import { latest as API_URL } from "../../../../config/api";
import { rateChart, rateByHotel, rateByProductionBar, rateByTrending } from "../widgets/Charts";
import Helpers, { dateFormat, number_format, windowsActive, is_better_arrow } from "../../../../config/Helpers";
import ReactEcharts from "echarts-for-react";
import axios from "axios";

const postUrlLogin = API_URL + "widgets";

class General extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            review : {
                current_year : {
                    availably_room_night : 0,
                    rate_occupancy : 0,
                    room_night_occupancy : 0,
                    room_night_oos_stock : 0,
                    room_night_stock : 0,
                    room_stock : 0,
                },
                last_year    : {
                    availably_room_night : 0,
                    rate_occupancy : 0,
                    room_night_occupancy : 0,
                    room_night_oos_stock : 0,
                    room_night_stock : 0,
                    room_stock : 0,
                },
                _vs_ : {
                    availably_room_night : 0,
                    rate_occupancy : 0,
                    room_night_occupancy : 0,
                    room_night_oos_stock : 0,
                    room_night_stock : 0,
                    room_stock : 0
                }
            },
            data_rate_hotel : {
                names : [], 
                percent_total_hotels : [], 
                values : []
            },
            data_production : {
                names : [],
                values : []
            },
            data_trending_time : {
                months : [],
                property_names : [],
                values : []
            }
        }
        this.getOptionTypeBar   = this.getOptionTypeBar.bind(this);
        this.getDefaultValues = this.getDefaultValues.bind(this)
    }

    getDefaultValues(){
        return {
            review : {
                current_year : {
                    availably_room_night : 0,
                    rate_occupancy : 0,
                    room_night_occupancy : 0,
                    room_night_oos_stock : 0,
                    room_night_stock : 0,
                    room_stock : 0,
                },
                last_year    : {
                    availably_room_night : 0,
                    rate_occupancy : 0,
                    room_night_occupancy : 0,
                    room_night_oos_stock : 0,
                    room_night_stock : 0,
                    room_stock : 0,
                },
                _vs_ : {
                    availably_room_night : 0,
                    rate_occupancy : 0,
                    room_night_occupancy : 0,
                    room_night_oos_stock : 0,
                    room_night_stock : 0,
                    room_stock : 0
                }
            },
            data_rate_hotel : {
                names : [], 
                percent_total_hotels : [], 
                values : []
            },
            data_production : {
                names : [],
                values : []
            },
            data_trending_time : {
                months : [],
                property_names : [],
                values : []
            }
        }
    }
    getOptionTypeBar = (chart) => {

        if(chart === "data_rate"){
            return rateChart(this.state.review.current_year.rate_occupancy);
        }else if(chart === "data_rate_hotel"){
            return rateByHotel(this.state.data_rate_hotel);
        }else if(chart === "data_production"){
            return rateByProductionBar(this.state.data_production);
        }else if(chart === "data_trending_time"){
            return rateByTrending(this.state.data_trending_time);
        }
    }

    componentWillReceiveProps(props) {

        let request_set = Object.keys(props.response_request).length,
        $self = this;
        if (request_set > 0){
            let result = props.response_request["result"];
            this.setState({ 
                review : (Object.keys(result["occupancy_widget"]).length > 0) ? result["occupancy_widget"]["review"] : this.getDefaultValues().review,
                data_rate_hotel : (Object.keys(result["property_widget"]).length > 0) ? result["property_widget"] : this.getDefaultValues().data_rate_hotel,
                data_production : (Object.keys(result["production_widget"]).length > 0) ? result["production_widget"] : this.getDefaultValues().data_production,
                data_trending_time : (Object.keys(result["trending_time_widget"]).length > 0) ? result["trending_time_widget"] : this.getDefaultValues().data_trending_time
            })
        }
    }
    render() {
        return (
            <section>
                <div className={"datagrid-widget occupancy-general"}>
                    <div className="container-fluid">
                        <div className="row header-widget">
                            <div className="col-md-12 options-widget">
                                <span className="title">OCCUPANCY &amp; AVAILABILITY</span>
                                
                                <span className="opt remove-widget hide">
                                    <img src={DeleteFilter} />
                                </span>
                            </div>
                        </div>
                        <div className="current-values">
                            <div className="row">
                                <div className="container-review">
                                    <div className="wdg-occupancy">
                                        <span className="title">OCCUPANCY RATE</span>
                                        <span className="highlight-title">
                                            <ReactEcharts
                                                option={windowsActive(this.props, "occupancy", "general_occupancy") === true ? this.getOptionTypeBar("data_rate") : {} }
                                                notMerge={true}
                                                lazyUpdate={true}
                                                theme={"theme_name"}
                                            />
                                        </span>
                                        <div className="footer">
                                            <div className="block-1">
                                                <span className="last-year">LAST YEAR</span>
                                                <span className="highlight-last-year">{this.state.review.last_year.rate_occupancy}%</span>
                                            </div>
                                            <div className="block-2">
                                                <span className={"rate-type " + is_better_arrow(this.state.review._vs_.rate_occupancy)}></span>
                                                <span className="highlight-rate">
                                                    { this.state.review._vs_.rate_occupancy }%
                                                </span>
                                            </div>
                                        </div> 
                                    </div>
                                    <div className="wdg-occupancy">
                                        <span className="title">ALLOTMENT</span>
                                        <span className="highlight-title">{ number_format(this.state.review.current_year.room_night_stock)}</span>
                                        <div className="footer">
                                            <div className="block-1">
                                                <span className="last-year">LAST YEAR</span>
                                                <span className="highlight-last-year">{number_format(this.state.review.last_year.room_night_stock)}</span>
                                            </div>
                                            <div className="block-2">
                                                <span className={"rate-type " + is_better_arrow(this.state.review._vs_.room_night_stock)}></span>
                                                <span className="highlight-rate">
                                                {this.state.review._vs_.room_night_stock}%
                                                </span>
                                            </div>
                                        </div> 
                                    </div>
                                    <div className="wdg-occupancy">
                                        <span className="title">AVAILABILITY</span>
                                        <span className="highlight-title">{number_format(this.state.review.current_year.availably_room_night)}</span>
                                        <div className="footer">
                                            <div className="block-1">
                                                <span className="last-year">LAST YEAR</span>
                                                <span className="highlight-last-year">{number_format(this.state.review.last_year.availably_room_night)}</span>
                                            </div>
                                            <div className="block-2">
                                                <span className={"rate-type " + is_better_arrow(this.state.review._vs_.availably_room_night)}></span>
                                                <span className="highlight-rate">
                                                {this.state.review._vs_.availably_room_night}%
                                                </span>
                                            </div>
                                        </div> 
                                    </div>
                                    <div className="wdg-occupancy">
                                        <span className="title">R/N</span>
                                        <span className="highlight-title">{number_format(this.state.review.current_year.room_night_occupancy)}</span>
                                        <div className="footer">
                                            <div className="block-1">
                                                <span className="last-year">LAST YEAR</span>
                                                <span className="highlight-last-year">{number_format(this.state.review.last_year.room_night_occupancy)}</span>
                                            </div>
                                            <div className="block-2">
                                                <span className={"rate-type " + is_better_arrow(this.state.review._vs_.room_night_occupancy)}></span>
                                                <span className="highlight-rate">
                                                {this.state.review._vs_.room_night_occupancy}%
                                                </span>
                                            </div>
                                        </div> 
                                    </div>
                                    <div className="wdg-occupancy">
                                        <span className="title">R/N OOS</span>
                                        <span className="highlight-title">{this.state.review.current_year.room_night_oos_stock}</span>
                                        <div className="footer">
                                            <div className="block-1">
                                                <span className="last-year">LAST YEAR</span>
                                                <span className="highlight-last-year">{this.state.review.last_year.room_night_oos_stock}</span>
                                            </div>
                                            <div className="block-2">
                                                <span className={"rate-type " + is_better_arrow(this.state.review._vs_.room_night_oos_stock)}></span>
                                                <span className="highlight-rate">
                                                    {this.state.review._vs_.room_night_oos_stock}%
                                                </span>
                                            </div>
                                        </div> 
                                    </div>
                                </div>
                            </div>
                        </div>   
                    </div>
                </div>
                <div className={"datagrid-widget adr"}>
                    <div className="container-fluid">
                        <div className="row header-widget">
                            <div className="col-md-12 options-widget">
                                <span className="title">PROPERTIES</span>
                                
                                <span className="opt remove-widget hide">
                                    <img src={DeleteFilter} />
                                </span>
                            </div>
                        </div>
                        <div className="current-values">
                            <div className="row">
                                <ReactEcharts
                                    option={windowsActive(this.props, "occupancy", "general_occupancy") === true ? this.getOptionTypeBar("data_rate_hotel") : {} }
                                    notMerge={true}
                                    lazyUpdate={true}
                                    theme={"theme_name"}
                                />
                            </div>
                        </div>   
                    </div>
                </div>
                <div className={"datagrid-widget room_type"}>
                    <div className="container-fluid">
                        <div className="row header-widget">
                            <div className="col-md-12 options-widget">
                                <span className="title">PRODUCTION</span>

                                <span className="opt remove-widget hide">
                                    <img src={DeleteFilter} />
                                </span>
                            </div>
                        </div>
                        <div className="current-values">
                            <div className="row">
                                <ReactEcharts
                                    option={windowsActive(this.props, "occupancy", "general_occupancy") === true ? this.getOptionTypeBar("data_production") : {} }
                                    notMerge={true}
                                    lazyUpdate={true}
                                    theme={"theme_name"}
                                    
                                    onChartReady={this.onChartReadyCallback}
                                    ref={(e) => { this._echarRoomType = e; }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"datagrid-widget trending"}>
                    <div className="container-fluid">
                        <div className="row header-widget">
                            <div className="col-md-12 options-widget">
                                <span className="title">PRODUCTION BY ROOM</span>
                                <span className="opt remove-widget hide">
                                    <img src={DeleteFilter} />
                                </span>
                            </div>
                        </div>
                        <div className="current-values">
                            <div className="row">
                                <div className="container-review">
                                    <ReactEcharts
                                        option={windowsActive(this.props, "occupancy", "general_occupancy") === true ? this.getOptionTypeBar("data_trending_time") : {} }
                                        notMerge={true}
                                        lazyUpdate={true}
                                        theme={"theme_name"}
                                        
                                        onChartReady={this.onChartReadyCallback}
                                        ref={(e) => { this._echarRoomType = e; }}
                                    />
                                </div>
                            </div>
                        </div>   
                    </div>
                </div>   
            </section>
        )
    }
}

export default General



// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/occupancy/views/General.js